module.exports = __webpack_public_path__ + "img/Unidad21-7.cbc809eb.png";